import { Link } from '@tanstack/react-router';

import { Icon } from './icons';

export interface BreadcrumbItem {
  label: string;
  href: string;
}

interface BreadcrumbsProps {
  items: BreadcrumbItem[];
  /** GTM `data-track` id, forwarded onto every crumb link. */
  dataTrack?: string;
  /** GTM `data-track-context`, forwarded onto every crumb link. */
  dataTrackContext?: string;
}

export function Breadcrumbs({ items, dataTrack, dataTrackContext }: BreadcrumbsProps) {
  return (
    <nav aria-label="Breadcrumb">
      <ol className="text-static-14 flex w-full flex-row items-center justify-start gap-8">
        {items.map((item, index) => (
          <li key={item.label} className="flex items-center gap-8">
            {index > 0 && (
              <Icon
                id="chevron-right"
                className="text-button-primary-bg"
                size="16"
                aria-hidden="true"
              />
            )}
            <Link
              to={item.href}
              data-track={dataTrack}
              data-track-context={dataTrackContext}
              className="text-button-primary-bg hover:text-button-primary-bg-hover focus-visible:outline-button-primary-bg focus-visible:outline-2"
            >
              {item.label}
            </Link>
          </li>
        ))}
      </ol>
    </nav>
  );
}
